import { useParams } from "react-router-dom";
import i18n from "@/i18n";
import { AuditCard } from "@/features/Audit/AuditCard";
import { C3StaticDataEditCard } from "./edit_card";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const C3StaticDataEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <C3StaticDataEditCard
          id={Number(id)}
          client={Clients.C3}
          table_name={Tables.C3_STATIC_DATA}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.C3}
          audit_table_name={Tables.C3_STATIC_DATA}
        />
      </div>
    </div>
  );
};
